<template>
  <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute fixed-top">
    <div class="md-toolbar-row md-offset">
      <div class="md-toolbar-section-start">
        <div slot="brand" class="navbar-wrapper">
          <a class="navbar-brand" href="https://www.sports4me.at/">
            <div class="logo"></div>
          </a>
        </div>
        <!-- <h3 class="md-title">{{ $route.name }}</h3> -->
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>

        </md-button>

        <div class="md-collapse test" :class="{ 'off-canvas-sidebar': responsive }">
          <md-list>
            <md-list-item href="#/challengeList" @click="toggleSidebar">
              <md-icon>emoji_events</md-icon>
              Challenges
            </md-list-item>
            <md-list-item href="#/login" @click="toggleSidebar">
              <md-icon>fingerprint</md-icon>
              Anmelden
            </md-list-item>
            <md-list-item href="#/register" @click="toggleSidebar">
              <md-icon>person_add</md-icon>
              Registrieren
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "User"
    }
  },
  data() {
    return {
      responsive: false,
      defaultImage: "https://images.sports4me.at/img/default-avatar.png"
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleSidebar() {
      if(this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
      else {
        this.$sidebar.displaySidebar(true);
      }
    },
    onResponsiveInverted() {
      if (window.innerWidth <= 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    document.documentElement.dataset.scroll = 0;
    document.addEventListener("scroll", () => {
      document.documentElement.dataset.scroll = window.scrollY;
    });
  }
};
</script>
<style>
  @media (max-width: 991px) {
    .full-page.nav-open .md-collapse.off-canvas-sidebar {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
    .full-page.nav-open .md-toolbar-section-end .md-toolbar-toggle, .full-page.nav-open .md-toolbar-section-start, .full-page.nav-open .wrapper-full-page {
        -webkit-transform: translate3d(-260px,0,0);
        transform: translate3d(-260px,0,0);
    }
  }
  .navbar-brand .logo {
    width: 200px;
    height: 70px;
    background-image: url(https://images.sports4me.at/s4m-img/logos/sports4me.png);
    background-size: contain;
    background-repeat: no-repeat;
  }
  html:not([data-scroll="0"]) .navbar-brand .logo {
    background-image: url(https://images.sports4me.at/s4m-img/logos/sports4me_dark.png);
  }
  html:not([data-scroll="0"]) .fixed-top {
      position: fixed;
      top: 0;
      background-color: rgba(43, 42, 41, 0.8) !important;
      box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
  }
</style>
<style lang="scss" scoped>
.md-toolbar {
  position: fixed;
}
.fixed-top {
  position: fixed;
  background-color: white;
}
.navbar-brand > img {
  max-height: 65px;
}
</style>
